// extracted by mini-css-extract-plugin
export var section = "_34-1";
export var topNav = "_34-0";